





















import { Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import PhoneInput from '@/modules/login/components/common/PhoneInput.vue'
import LoginStore from '@/modules/login/stores/LoginStore'
import FormCard from '@/modules/login/components/common/FormCard.vue'
import SubmitButton from '@/modules/login/components/common/SubmitButton.vue'

@Component({
  components: { SubmitButton, FormCard, PhoneInput },
})
export default class LoginForm extends Vue {
  isPending: boolean = false

  get phone(): string {
    return LoginStore.phone
  }

  set phone(value: string) {
    LoginStore.setPhone(value)
  }

  get hasError(): boolean {
    return !!LoginStore.errorMessage
  }

  submitForm() {
    this.isPending = true

    LoginStore.submitPhone().finally(() => (this.isPending = false))
  }
}
